<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="baseView.mode != 'review'"
    :backButtonRoute="backButtonRoute"
    ref="supplier-payment"
    :data-model="dataModel"
    :backRouteAppend="
      this.baseView.query && this.baseView.query.SUP_ID
        ? undefined
        : 'SupplierCode'
    "
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :getHeaderToolbar="getHeaderToolbar"
    :paging="false"
  >
  </TransactionTemplate>
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { SupplierPaymentService } from "../../_services/api/suppliers/supplier-payment.service";
import { SupplierService } from "../../_services/api/suppliers/supplier.service";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { getDefaultUserSettings, getFactorByCode } from "../../_store/helpers";
import { SupplierInvoiceService } from "../../_services/api/purchasing/supplier-invoice.service";
import CheckBox from "devextreme/ui/check_box";
import { FeatureStorage } from "../../_services/storage";
import { mapGetters } from "vuex";
import { DivisionService } from "../../_services/api/sales/division.service";
import { BranchService } from "../../_services/api/sales/branch.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { formatNumber } from "devextreme/localization";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";

import { FxToBaseCurrency } from "../../_helpers/formulas/sales-formulas";
import ArrayStore from "devextreme/data/array_store";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      CheckStockWriteOff: false,
      loaded: false,
      setLoading: false,
      headerEndpoint: undefined,
      dataModel: {
        AccountingPeriodCode: undefined,
        Reference: undefined,
        DateIn: undefined,
        BankAccountCode: undefined,
        ChequeDate: undefined,
        PresentedDate: undefined,
        DueBefore: undefined,
        PayeeName: "",
        Balance: 0,
        BankAccountName: "",
        BSBNO: "",
        BankAccountNo: "",
        CurrencyCode: "",
        ExchangeRate: "",
        SupplierCode: undefined,
        Invoice: "",
        InvoiceDate: undefined,
        DueDate: undefined,
        Amount: 0,
        FXVarianceRounding: 0,
        FXIncTaxAmount: 0,
        AllocationAmount: 0,
        BranchCode: "",
        FXDiscountAmount: 0,
        BuyRate: 1,
        IncTaxAmount: 0,
      },
      gridData: undefined,
      headerData: undefined,
      companyName: undefined,
      PaymentMaxDate: undefined,
      PaymentMinDate: new Date(),
      reload: false,
      validationSummary: [],
      cancelCompleteMenu: [],
      serverError: {},
      model: undefined,
      status: undefined,
      defaultDataModel: {
        DefaultBranchCode: null,
        DefaultDivisionCode: null,
        DefaultBranchDescription: null,
        DefaultDivisionDescription: null,
      },
      displayCurrencyCode: undefined,
      goBackRoute: "/supplier-transaction-history/",
      SupplierData: undefined,
      ChequeNumber: undefined,
      BaseCurrency: "AUD",
      SupplierCode: undefined,
      localDataSource: new ArrayStore({
        key: "Code",
        data: [],
      }),
      SelectedOnHeader: false,
    };
  },

  async mounted() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);

    if (this.baseView.query) {
      if (this.baseView.query.from) {
        this.goBackRoute = this.baseView.query.from;
      }

      if (this.baseView.query.SUP_ID) {
        var id = decodeURI(this.baseView.query.SUP_ID);

        await SupplierService.getByCode(JSON.parse(id)).then((res) => {
          this.SupplierData = res.data.value[0];

          this.dataModel["SupplierName"] = this.SupplierData.Name;
          this.dataModel["SupplierCode"] = this.SupplierData.Code;
        });
      }
    }
    this.initialized();
  },
  beforeDestroy() {},

  watch: {
    $route(to) {
      if (to.path == "/supplier-payment/create") {
        location.reload();
      }
    },
  },
  computed: {
    cancelPaymentMenuVisible() {
      return (
        this.baseView.mode == "review" &&
        this.headerData &&
        this.headerData.FriendlyStatus == "Unpresented" &&
        (this.headerData && this.headerData.CancelledByPaymentNo
          ? false
          : this.headerData && this.headerData.Cancellation == "N")
      );
    },
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    backButtonRoute() {
      return this.goBackRoute;
    },
    IsForeignCurrencyAccount() {
      return true;
      // return this.dataModel.CurrencyCode !== this.BaseCurrency;
    },
    getDetailsFilter() {
      let filterString = "";

      if (this.baseView.mode == "review") {
        filterString = ["CashPaymentCode eq " + this.baseView.id];
      } else {
        let fromRoute = decodeURI(this.goBackRoute);

        if (fromRoute == "/supplier-invoiced") {
          filterString = `SupplierCode eq '${this.SupplierCode}' and Code eq ${this.baseView.id}`;
        } else if (fromRoute.startsWith("/supplier-invoice/review/")) {
          filterString = `Code eq ${this.baseView.id} and FriendlyStatus ne 'Paid' and Balance ne 0`;
          if (this.dataModel.DueBefore != undefined) {
            filterString =
              filterString +
              ` and DueDate lt ${new Date(
                this.dataModel.DueBefore
              ).toFilterDateString()}`;
          }
        } else {
          filterString = `SupplierCode eq '${this.SupplierCode}' and FriendlyStatus ne 'Paid' and Balance ne 0`;
          if (this.dataModel.DueBefore != undefined) {
            filterString =
              filterString +
              ` and DueDate lt ${new Date(
                this.dataModel.DueBefore
              ).toFilterDateString()}`;
          }
        }

        if (this.dataModel.DateIn) {
          filterString += ` and InvoiceDate le ${new Date(
            this.dataModel.DateIn
          ).toFilterDateString()}`;
        }
      }

      return [filterString];
    },

    getScreenJson() {
      var screenJson = {
        title: "Supplier Payment",
        endpoint: {
          primary: this.baseView.mode !== "create" ? "CashPayment" : undefined,
          postProcess: this.supplierPaymentPostProcess,
        },
        headerData: {
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      dataField: "DateIn",
                      editorOptions: {
                        min: this.PaymentMinDate,
                        max: this.PaymentMaxDate,
                        allowUpdate: this.baseView.mode == "create",
                        onValueChanged: (e) => {
                          if (
                            e.value < this.PaymentMinDate ||
                            e.value > this.PaymentMaxDate
                          ) {
                            e.component.beginUpdate();
                            e.component.option("value", e.previousValue);
                            e.component.endUpdate();
                          } else {
                            this.DateInChanged(e);
                          }
                        },
                      },
                      required: true,
                    },
                    {
                      screenField: "BankAccount",
                      dataField: "BankAccountCode",
                      dataSourceConfig: {
                        endpoint: "api/BankRecord",
                        sort: {
                          selector: "AccountName",
                          asc: true,
                        },
                        filter:
                          this.baseView.mode == "review"
                            ? undefined
                            : this.BaseCurrency == this.dataModel.CurrencyCode
                            ? [
                                ["CurrencyCode", "=", this.BaseCurrency],
                                "and",
                                ["Inactive", "=", "N"],
                              ]
                            : [
                                [
                                  [
                                    ["CurrencyCode", "=", this.BaseCurrency],
                                    "or",
                                    [
                                      "CurrencyCode",
                                      "=",
                                      this.dataModel.CurrencyCode,
                                    ],
                                  ],
                                  "and",
                                  ["Inactive", "=", "N"],
                                ],
                              ],
                      },
                      editorOptions: {
                        allowUpdate: this.baseView.mode == "create",
                      },
                      label: {
                        text: "Bank Account",
                      },
                      required: true,
                      validationRules: [
                        {
                          type: "required",
                          message:
                            "Please select Bank Account before attempting to save this payment",
                        },
                      ],
                    },
                    {
                      screenField: "Reference",
                      dataField: "Reference",
                      editorOptions: {
                        maxLength: 100,
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Date",
                      dataField: "DueBefore",
                      label: {
                        text: "Due Before",
                      },
                      visible: this.baseView.mode !== "review",
                      editorOptions: {
                        showClearButton: true,
                        onValueChanged: () => {
                          this.onDueBeforeChanged();
                        },
                      },
                    },
                    {
                      screenField: "PayeeName",
                      editorOptions: {
                        maxLength: 100,
                      },
                    },
                    // {
                    //   screenField: "BankAccountName",
                    //   allowUpdate: false,
                    // },
                    // {
                    //   screenField: "BSBNO",
                    //   allowUpdate: false,
                    // },
                    // {
                    //   screenField: "BankAccountNo",
                    //   allowUpdate: false,
                    // },
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 2,
                      items: [
                        {
                          dataField: "CurrencyCode",
                          allowUpdate: false,
                          label: {
                            text: "Currency",
                          },
                          editorOptions: {
                            tabIndex: -1,
                          },
                        },
                        {
                          screenField: "ExchangeRate",
                          allowUpdate:
                            this.getCurrencyCode == "AUD" ? false : true,
                          editorOptions: {
                            onValueChanged: (e) => {
                              if (e.value <= 0) {
                                this.doValidation(
                                  `You have entered an exchange rate of ${formatNumber(
                                    e.value,
                                    e.component.option("format")
                                  )}, which is invalid. Please enter an exchange rate that is greater than 0.0000`
                                );

                                e.component.beginUpdate();
                                e.component.option("value", e.previousValue);
                                e.component.endUpdate();
                              } else {
                                if (e.event) this.onExchangeRateChange();
                              }
                            },
                            tabIndex:
                              this.getCurrencyCode == "AUD" ? -1 : undefined,
                          },
                          required: true,
                          validationRules: [
                            {
                              type: "custom",
                              validationCallback: (e) => {
                                e.rule.message = `You have entered an exchange rate of ${formatNumber(
                                  e.value,
                                  e.formItem.editorOptions.format
                                )}, which is invalid. Please enter an exchange rate that is greater than 0.0000`;

                                return e.value > 0;
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "FXAmount",
                      dataField: "FXIncTaxAmount",
                      editorOptions: {
                        onValueChanged: (e) => {
                          // if (e.value)
                          this.fxAmountValueChange(e);
                        },
                      },
                      label: {
                        text: "Amount(" + this.getCurrencyCode + ")",
                      },
                    },
                    {
                      screenField: "FXAmount",
                      dataField: "IncTaxAmount",
                      allowUpdate: true,
                      editorOptions: {
                        // readOnly: true,
                        onValueChanged: (e) => {
                          this.amountValueChange(e);
                        },
                      },
                      label: {
                        text: "Amount(" + this.BaseCurrency + ")",
                      },
                      // visible: this.BaseCurrency != this.getCurrencyCode,
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: this.baseView.mode == "create" ? undefined : "Code",
                text:
                  this.baseView.mode == "create"
                    ? "Create Supplier Payment"
                    : "Supplier Payment # ",
              },
              secondary: {
                dataField:
                  this.baseView.mode == "create" ? undefined : "PayeeName",
                text: this.baseView.mode == "create" ? undefined : " for ",
              },
            },
            secondary: {
              // dataField: "PayeeName",
              // text: undefined,
            },
          },
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: this.loaded
                ? this.baseView.mode == "review"
                  ? "CashPaymentDetail"
                  : undefined
                : undefined,
              filter: this.getDetailsFilter,
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.PostProcess,
              localDataList: this.baseView.mode != "review",
              items: this.localDataSource._array,
            },
            noDataMessage: {
              addNew: {
                class: "no-data",
                title: this.dataModel.SupplierCode
                  ? "No outstanding records"
                  : "Uh-oh!",
                message: this.dataModel.SupplierCode
                  ? "There are no outstanding records for the selected supplier"
                  : "We are struggling to find what you are looking for. Try altering your search criteria",
              },
            },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: true,
            review: false,
          },
          columns: [
            {
              screenField: "CheckInclude",
              allowEditing: false,
              defaultValue: false,
              valueChangeCallBack: this.checkBoxValueChange,
              allowHiding: false,
              showInColumnChooser: false,
              fixed: true,
              fixedPosition: "left",
              label: "",
              width: 50,
              minWidth: 50,
              visible: this.baseView.mode != "review",
              cssClass: "check-include",
              makeDisabled: (cellInfo) => {
                if (
                  new Date(this.dataModel.DateIn) >=
                  new Date(cellInfo.data.DateIn.replace("Z", ""))
                ) {
                  if (
                    !cellInfo.data.CheckInclude &&
                    cellInfo.data.Disabled == true &&
                    this.SelectedOnHeader != false
                  ) {
                    cellInfo.data.Disabled = false;
                    cellInfo.data.CheckInclude = true;
                    this.checkBoxValueChange(
                      {
                        event: true,
                        value: true,
                      },
                      cellInfo
                    );
                  }
                  return false;
                } else {
                  if (cellInfo.data.CheckInclude) {
                    cellInfo.data.CheckInclude = false;
                    cellInfo.data.Disabled = true;
                    this.checkBoxValueChange(
                      {
                        event: true,
                        value: false,
                      },
                      cellInfo
                    );
                  }
                  return true;
                }
              },
            },
            {
              screenField: "Invoice",
              label: "GCORP Invoice",
              allowHiding: false,
              dataField:
                this.baseView.mode == "review" ? "GcorpInvoiceCode" : "Code",
              width: ColumnWidth.TransactionNo.width,
              hyperlink: {
                url: `supplier-invoice/review/__ID__`,
                dataField:
                  this.baseView.mode == "review" ? "GcorpInvoiceCode" : "Code",
                target: "_blank",
              },
              allowSearch: true,
            },
            {
              screenField: "DateIn",
              minWidth: "auto",
              dataField: "DateIn",
              allowSearch: false,
              visible: this.baseView.mode == "create",
            },
            {
              screenField: "Invoice",
              label: "Supplier Ref",
              allowHiding: false,
              dataField:
                this.baseView.mode == "create"
                  ? "InvoiceNo"
                  : "SuppliersInvoice",
              allowSearch: true,
            },
            {
              screenField: "InvoiceDate",
              minWidth: "auto",
              dataField:
                this.baseView.mode == "create"
                  ? "InvoiceDate"
                  : "SuppliersInvoiceDate",
              allowSearch: false,
            },
            {
              screenField: "DueDate",
              dataField:
                this.baseView.mode == "create"
                  ? "DueDate"
                  : "SuppliersInvoiceDueDate",
              allowSearch: false,
            },
            {
              screenField: "ExchangeRate",
              label: "Exchange Rate",
              format: "Decimal-6-4",
              type: "Decimal",
              width: ColumnWidth.ExchangeRate.width,
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              allowSearch: false,
            },
            {
              screenField: "FXAmount",
              dataField:
                this.baseView.mode == "create" ? "FXAmount" : "FXAmount",
              visible: this.baseView.mode == "create",
              width: ColumnWidth.Amount.width,
              label: () => {
                return `Amount (${this.getCurrencyCode})`;
              },
              allowSearch: true,
            },
            {
              screenField: "FXBalance",
              type: "EditableDecimal",
              visible: this.baseView.mode == "create",
              width: ColumnWidth.Amount.width,
              label: () => {
                return `Balance (${this.getCurrencyCode})`;
              },
              allowSearch: false,
            },
            {
              screenField: "FXDiscount",
              dataField:
                this.baseView.mode == "create"
                  ? "FXDiscount"
                  : "FXDiscountAmount",
              type: "EditableDecimal",
              showEditorAlways: this.baseView.mode == "create",
              // visibleIndex: this.baseView.mode == "review" ? 7 : undefined,
              value: 0,
              allowEditing: true,
              width: ColumnWidth.Amount.width,
              label: () => {
                return `Discount (${this.getCurrencyCode})`;
              },
              makeDisabled: (data) => {
                if (data.data.CheckInclude == true) {
                  return false;
                } else return true;
              },
              allowSearch: false,
            },
            {
              screenField: "Discount",
              name: "Discount",
              dataField: "Discount",
              format: "Decimal-16-2",
              // type: "Decimal",
              type: "EditableDecimal",
              allowEditing: false,
              width: ColumnWidth.Amount.width,
              label: () => {
                return `Discount (${this.BaseCurrency})`;
              },
              visible: true,
              allowSearch: false,
            },
            {
              screenField: "FXAllocation",
              dataField: "FXAllocationAmount",
              allowEditing: true,
              type:
                this.baseView.mode == "review" ? "Decimal" : "EditableDecimal",
              width: ColumnWidth.Amount.width,
              // visibleIndex: this.baseView.mode == "review" ? 6 : undefined,
              label: () => {
                return `Allocated (${this.getCurrencyCode})`;
              },
              showEditorAlways: this.baseView.mode == "create",
              value: (data) => {
                if (data.data.CheckInclude == false) {
                  data.data.Amount = 0;
                  return data.data.Amount;
                }
              },
              makeDisabled: (data) => {
                if (data.data.CheckInclude == true) {
                  return false;
                } else return true;
              },
              allowSearch: false,
            },
            {
              screenField: "Amount",
              name: "Allocated",
              dataField: "AllocationAmount",
              format: "Decimal-16-2",
              type: "Decimal",
              allowEditing: false,
              width: ColumnWidth.Amount.width,
              label: () => {
                return `Allocated (${this.BaseCurrency})`;
              },
              visible: true,
              allowSearch: false,
            },

            {
              screenField: "Amount",
              name: "Gain / Loss",
              type: "Decimal",
              format: "Decimal-16-2",
              label: () => {
                return `Gain / Loss (${this.BaseCurrency})`;
              },
              dataField: "GainOrLoss",
              width: ColumnWidth.Amount.width,
              visible: this.IsForeignCurrencyAccount,
              allowSearch: false,
            },
          ],

          valueChangedEventListners: [
            {
              dataField: "FXAllocationAmount",
              listner: (e, lineData) => {
                lineData.data.FXAllocationAmount = e.value;
                lineData.data.FXAllocation = e.value;

                lineData.data.AllocationAmount = FxToBaseCurrency(
                  e.value,
                  lineData.data.ExchangeRate
                );

                lineData.data.GainOrLoss = this.calculateGainOrLoss(
                  lineData.data
                );

                this.mergeWithReviewView(
                  lineData.data.FXAllocationAmount == 0 ? false : true,
                  lineData.data
                );
              },
            },
            {
              dataField: "FXDiscount",
              listner: (e, lineData) => {
                lineData.data.FXDiscount = e.value;
                lineData.data.Discount = FxToBaseCurrency(
                  e.value,
                  lineData.data.ExchangeRate
                );

                lineData.data.FXAllocationAmount =
                  lineData.data.FXBalance - e.value;
                lineData.data.AllocationAmount = FxToBaseCurrency(
                  lineData.data.FXAllocationAmount,
                  lineData.data.ExchangeRate
                );

                lineData.data.GainOrLoss = this.calculateGainOrLoss(
                  lineData.data
                );

                this.mergeWithReviewView(
                  lineData.data.FXDiscount == 0 ? false : true,
                  lineData.data
                );
              },
            },
          ],
        },
        footerData: {
          footerItems: [
            {
              screenField: "FXAllocation",
              location: "right",
              value: 0,
              dataField: "AllocationAmount",
              label: "Allocated (" + this.getCurrencyCode + ")",
              customCalc: (headerData, gridItems) => {
                var total = 0;
                gridItems.forEach((element) => {
                  if (element.CheckInclude)
                    total = total + element.FXAllocationAmount;
                });
                return total;
              },
            },
            {
              screenField: "FXDiscount",
              dataField: "BalanceFX",
              location: "right",
              label: "Balance (" + this.getCurrencyCode + ")",
              value: 0,
              visible: true,
              allowEditing: false,
              // eslint-disable-next-line no-unused-vars
              customCalc: (headerData, gridItems) => {
                var Allocated = 0;
                gridItems.forEach((element) => {
                  if (element.CheckInclude)
                    Allocated = Allocated + element.FXAllocationAmount;
                });
                return headerData.FXIncTaxAmount - Allocated;
              },
            },
            {
              screenField: "FXDiscount",
              dataField: "Discount",

              location: "right",
              label: "Discount Taken (" + this.BaseCurrency + ")",
              value: 0,
              allowEditing: false,
              customCalc: (headerData, gridItems) => {
                var total = 0;

                // if (this.baseView.mode == "review") {
                //   total = headerData.Discount;
                // } else {
                gridItems.forEach((element) => {
                  if (this.baseView.mode == "review")
                    total += element.DiscountAmount;
                  else if (element.CheckInclude)
                    total = total + element.Discount;
                });
                // }
                return total;
              },
            },
            // {
            //   screenField: "FXTotal",
            //   dataField: "FXTotal",
            //   location: "right",
            //   value: 0,
            //   customCalc: (headerData, gridItems) => {
            //     if (this.baseView.mode == "review")
            //       return (
            //         headerData.FXIncTaxAmount + headerData.FXDiscountAmount
            //       );

            //     var total = 0;
            //     gridItems.forEach((element) => {
            //       if (element.CheckInclude)
            //         total =
            //           total + element.FXAllocationAmount + element.FXDiscount;
            //     });
            //     return total;
            //   },
            //   label: "Amount (" + this.getCurrencyCode + ")",
            //   name: "Amount (FX)",
            // },

            // {
            //   screenField: "Total",
            //   dataField: "Total",
            //   location: "right",
            //   value: 0,
            //   customCalc: (headerData, gridItems) => {
            //     if (this.baseView.mode == "review")
            //       return headerData.IncTaxAmount + headerData.DiscountAmount;

            //     var total = 0;
            //     gridItems.forEach((element) => {
            //       if (element.CheckInclude)
            //         total = total + element.AllocationAmount + element.Discount;
            //     });
            //     return total;
            //   },
            //   label: "Amount (" + this.BaseCurrency + ")",
            //   name: "Amount (Base)",
            //   visible: this.getCurrencyCode != this.BaseCurrency,
            // },
            {
              screenField: "Total",
              dataField: "Total",
              location: "right",
              value: 0,
              customCalc: (headerData, gridItems) => {
                var total = 0;
                gridItems.forEach((element) => {
                  if (element.CheckInclude) total = total + element.GainOrLoss;
                });
                return total;
              },
              label: `Gain / Loss (${this.BaseCurrency})`,
              name: "Gain / Loss (Base)",
              // visible: this.getCurrencyCode != this.BaseCurrency,
            },
          ],
        },
      };
      return screenJson;
    },
    getCurrencyCode() {
      if (this.dataModel.CurrencyCode) return this.dataModel.CurrencyCode;
      else return this.displayCurrencyCode;
    },

    getHeaderToolbar() {
      return {
        headerToolbar: {
          screenName: "Supplier Payment",
          pdf: this.baseView.mode == "review",
          email: this.baseView.mode == "review",
          audit: this.baseView.mode == "review",
          status: this.baseView.mode == "review",
          notes: false,
          save: this.baseView.mode != "review",
          saveCallback: this.saveSupplierPayment,
          formContentReady: (e) => {
            if (e && this.baseView.mode != "review" && this.loaded)
              this.headerFormContentReady(e);
          },
          toolbarFormItems: [
            {
              screenField: "Supplier",
              dataField: "SupplierCode",
              cssClass: "toolbar-supplier-label",
              visible: this.baseView.mode != "review",
              editorOptions: {
                dropDownOptions: {
                  minWidth: 300,
                },
                width: 300,
                placeholder: "Supplier Name",
                // onValueChanged: this.onCustomerCodeValueChanged.bind(this),
                showClearButton: true,
                // onItemClick: this.onSupplierCodeItemClicked.bind(this),
                onSelectionChanged: this.onSupplierCodeItemClicked.bind(this),
                searchTimeout: 10,
              },
              label: {
                text: "Supplier",
                visible: false,
              },
              required: true,
            },
          ],
          customButtons: [
            {
              label: "save",
              icon: "..",
              type: " ",
              click: "",
              menu: [
                {
                  label: "Credit Comments",
                  clickAction: "",
                },
              ],
            },
          ],
          emailMenuItems: {
            referenceNoField: "Code",

            makeDisabled: (dataModel, emailRecords) => {
              var items = [];

              emailRecords.forEach((element) => {
                items.push({
                  ReportDisplayName: element.ReportDisplayName,
                  ScreenName: element.ScreenName,
                  ScreenLayoutApplicationFeatureCode:
                    element.ScreenLayoutApplicationFeatureCode,
                  TransactionCode: element.TransactionCode,
                  disabled: element.disabled,
                });
              });

              return items;
            },
          },

          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // disabled: true,
                  },
                },
              ],
            },
          ],

          ellipsis: {
            menuItems: this.cancelCompleteMenu,
            visible: this.cancelPaymentMenuVisible,
            clickAction: (e) => {
              if (e.itemData.menuText == "Cancel Payment") {
                this.cancelPayment();
              }
            },
            disabled:
              !FeatureStorage.checkPermission("CashPayment", "create") ||
              this.cancelCompleteMenu.length == 0,
          },
        },
      };
    },
  },
  methods: {
    headerFormContentReady(e) {
      setTimeout(() => {
        let toolBarFormInstance = e.component;

        if (
          toolBarFormInstance &&
          toolBarFormInstance.getEditor("SupplierCode")
        )
          toolBarFormInstance
            .getEditor("SupplierCode")
            .instance()
            .focus();
      }, 500);
    },
    async onSupplierCodeItemClicked(e) {
      if (!e.selectedItem) {
        this.localDataSource.clear();
        this.updateHeaderCheckBox(this.localDataSource._array);
        this.updateHeaderCheckBoxValue(false);
        this.upDateDataSet();
        return;
      }
      // if (this.localDataSource._array.length > 0)

      this.setLoading = true;
      this.SupplierCode = undefined;

      var supplierDetails = e.selectedItem;

      this.dataModel.SupplierCode = supplierDetails.Code;
      this.dataModel.PayeeName = supplierDetails.Name;
      this.dataModel.BankAccountName = supplierDetails.BankAccountName;
      this.dataModel.BSBNO = supplierDetails.Bsbno;
      this.dataModel.BankAccountNo = supplierDetails.BankAccountNo;
      this.dataModel.CurrencyCode = supplierDetails.CurrencyCode;

      await CompanyCurrencyService.getByCurrencyCode(
        this.dataModel.CurrencyCode
      ).then((res) => {
        if (res.data.value.length > 0) {
          this.dataModel.ExchangeRate = res.data.value[0].SellRate;
          this.dataModel.BuyRate = res.data.value[0].SellRate;
        }
      });

      this.SupplierCode = this.dataModel.SupplierCode;
      await this.getSupplierInvoiceDetails();
      // this.updateHeaderCheckBoxValue(true);

      this.setLoading = false;
      this.upDateDataSet();
    },
    upDateDataSet() {
      if (
        this.$refs["supplier-payment"] &&
        this.$refs["supplier-payment"].$refs["transactionGrid"]
      )
        this.$refs["supplier-payment"].$refs["transactionGrid"].setDataSource(
          this.localDataSource._array
        );
      this.updateHeaderCheckBox(this.localDataSource._array);
      if (
        this.$refs["supplier-payment"] &&
        this.$refs["supplier-payment"].$refs["transactionGrid"]
      )
        this.$refs["supplier-payment"].$refs["transactionGrid"].gridRepaint();
    },
    async getSupplierInvoiceDetails() {
      await this.localDataSource.clear();
      await SupplierPaymentService.getSupplierInvoiceDetails({
        filter: this.getDetailsFilter,
        // select:
        //   "Code,ExchangeRate,InvoiceNo,InvoiceDate,DueDate,FXAmount,FXBalance,Amount,AccountsPayableCode",
      })
        .then((res) => {
          for (let index = 0; index < res.data.value.length; index++) {
            const element = res.data.value[index];
            element["CheckInclude"] = true;
            element.BranchCode = this.defaultDataModel.DefaultBranchCode;
            element.DivisionCode = this.defaultDataModel.DefaultDivisionCode;
            element.FXDiscount = 0;
            element.Discount = 0;

            element.FXBalance = element.FXBalance || 0;
            element.FXAllocationAmount = element.FXBalance;
            element.AllocationAmount = FxToBaseCurrency(
              element.FXBalance,
              element.ExchangeRate
            );
            element.GainOrLoss = this.calculateGainOrLoss(element);
            this.localDataSource.insert(element);
          }

          if (res.data.value.length == 0) {
            this.localDataSource.clear();
            this.updateHeaderCheckBoxValue(false);
          }
        })
        .catch(() => {
          this.setLoading = false;
        });
    },
    async DateInChanged(e) {
      // this.setLoading = true;
      if (e.value > this.dataModel.ChequeDate)
        this.dataModel.ChequeDate = e.value;
      // await this.getSupplierInvoiceDetails();
      // this.setLoading = false;
      // this.upDateDataSet();
      //  if (
      //   this.$refs["supplier-payment"] &&
      //   this.$refs["supplier-payment"].$refs["transactionGrid"]
      // )
      //   this.$refs["supplier-payment"].$refs["transactionGrid"].gridRepaint();
    },
    async onDueBeforeChanged() {
      this.setLoading = true;
      await this.getSupplierInvoiceDetails();
      this.setLoading = false;
      this.upDateDataSet();
    },
    async cancelPayment() {
      let confirmCancel = await this.$confirm(
        "Do you want to cancel this payment?",
        "Cancel Payment"
      );

      if (confirmCancel) {
        await CompanyService.getByCompanyCode(
          getDefaultUserSettings().CompanyCode
        ).then(async ({ data }) => {
          const payload = {
            Code: this.model.Code,
            DateIn: this.model.DateIn,
            Reference: this.model.Reference,
            ChequeDate: this.model.ChequeDate,
            TransactionType: "CPAY",
            AccountPeriod: this.model.AccountingPeriodCode,
            ChequeNumber: this.headerData.ChequeNo,
            GstAmount: this.model.FXIncTaxAmount,
            CancelCashPaymentDetails: [],
          };
          this.gridData.forEach((element) => {
            payload.CancelCashPaymentDetails.push({
              AccountCode: `${element.PaymentAPDataXRef}`,
              Amount: element.AllocationAmount,
              FxVariance: element.FXVarianceAmount,
              CompanyCode: getDefaultUserSettings().CompanyCode,
              CompanyName: data.value[0].Name, // element.,
              BranchCode: getDefaultUserSettings().BranchCode,
              BranchDescription: this.defaultDataModel.DefaultBranchDescription, // element.,
              DivisionCode: getDefaultUserSettings().DivisionCode,
              DivisionDescription: this.defaultDataModel
                .DefaultDivisionDescription, // element.,
            });
          });
          await SupplierPaymentService.cancelPayment(payload)
            .then(async (res) => {
              if (res) {
                // this.setLoading = false;
                this.$notify(
                  `Supplier Payment ${res.data.CancelledPaymentCode} Cancelled successfully`,
                  "success"
                );
                // location.reload();

                this.setIgnoreRouteChangeConfirmation();
                const { from: parentPage } = this.baseView.query;
                await this.$router.push({
                  path: `/supplier-payment/review/${res.data.CancellingPaymentCode}`,
                  query: {
                    from: parentPage,
                  },
                });

                this.$router.go(0);
              }
            })
            .catch((err) => {
              this.setLoading = false;
              this.serverError = {
                err: err,
                msg: "Cancel Payment Failed",
                time: new Date().getTime(),
              };
            });
        });
      }
    },
    async initialized() {
      if (this.baseView.mode == "review") {
        await BranchService.getDefault().then((res) => {
          this.defaultDataModel.DefaultBranchCode = this.dataModel.BranchCode =
            res.data.value[0].Code;
          this.defaultDataModel.DefaultBranchDescription =
            res.data.value[0].Description;
        });
        await DivisionService.getDefault().then((res) => {
          this.defaultDataModel.DefaultDivisionCode = this.dataModel.DivisionCode =
            res.data.value[0].Code;
          this.defaultDataModel.DefaultDivisionDescription =
            res.data.value[0].Description;
        });
        await SupplierPaymentService.getCustomData({
          url: "CashPayment",
          filter: `Code eq ${this.baseView.id}`,
        }).then((res) => {
          if (res.data.value.length > 0)
            if (res.data.value[0].Cancellation != "Y") {
              this.model = res.data.value[0];
              this.cancelCompleteMenu = [
                {
                  menuText: "Cancel Payment",
                  disabled: res.data.value[0].Cancellation == "Y",
                  visible: res.data.value[0].Cancellation != "Y",
                },
              ];
            } else {
              this.cancelCompleteMenu = [];
            }
          else this.cancelCompleteMenu = [];
        });
        this.reload = false;
        this.loaded = true;
      } else {
        this.setLoading = true;

        this.setDateInValidation();
        await this.$store.dispatch("screenFactors/getFactors", [91]);
        if (getFactorByCode(91).FactorInt != 0)
          this.dataModel.BankAccountCode = `${getFactorByCode(91).FactorInt}`;

        CompanyService.getCompany().then(async (res) => {
          let companyDetails = res.data.value[0];
          if (companyDetails) {
            this.BaseCurrency = companyDetails.CurrencyCode;
          } else {
            this.BaseCurrency = "AUD";
          }
        });

        if (this.baseView.mode == "create") {
          if (getDefaultUserSettings().BranchCode) {
            this.defaultDataModel.DefaultBranchCode = this.dataModel.BranchCode = getDefaultUserSettings().BranchCode;
          } else {
            BranchService.getDefault().then((res) => {
              this.defaultDataModel.DefaultBranchCode = this.dataModel.BranchCode =
                res.data.value[0].Code;
              this.defaultDataModel.DefaultBranchDescription =
                res.data.value[0].Description;
            });
          }

          if (getDefaultUserSettings().DivisionCode) {
            this.defaultDataModel.DefaultDivisionCode = this.dataModel.DivisionCode = getDefaultUserSettings().DivisionCode;
          } else {
            DivisionService.getDefault().then((res) => {
              this.defaultDataModel.DefaultDivisionCode = this.dataModel.DivisionCode =
                res.data.value[0].Code;
              this.defaultDataModel.DefaultDivisionDescription =
                res.data.value[0].Description;
            });
          }

          this.dataModel.DateIn = new Date();
          this.dataModel.ChequeDate = new Date();
          const regex = /\/supplier\/review\//;
          this.dataModel.DueBefore =
            this.baseView.query.from == "/supplier" ||
            regex.test(this.baseView.query.from)
              ? new Date()
              : undefined;

          this.dataModel.DueDate = new Date();
        }

        let fromRoute = decodeURI(this.goBackRoute);

        if (fromRoute !== "/supplier" && this.baseView.id) {
          await SupplierInvoiceService.getBySupplierCode(this.baseView.id).then(
            (res) => {
              if (res.data.value.length > 0) {
                this.dataModel.SupplierCode = res.data.value[0].SupplierCode;
                this.dataModel.Invoice = res.data.value[0].invoiceNo;
                this.dataModel.InvoiceDate = res.data.value[0].invoiceDate;
                this.dataModel.DueDate = res.data.value[0].DueDate;
                this.dataModel.Amount = res.data.value[0].FXAmount;
                this.dataModel.AccountingPeriodCode =
                  res.data.value[0].AccountingPeriodCode;
              }
            }
          );
        }

        if (this.dataModel.SupplierCode)
          await SupplierService.getByCode(this.dataModel.SupplierCode).then(
            (res) => {
              if (res.data.value.length > 0) {
                this.dataModel.PayeeName = res.data.value[0].Name;
                this.dataModel.BankAccountName =
                  res.data.value[0].BankAccountName;
                this.dataModel.BSBNO = res.data.value[0].Bsbno;
                this.dataModel.BankAccountNo = res.data.value[0].BankAccountNo;
                this.dataModel.CurrencyCode = res.data.value[0].CurrencyCode;
              }
            }
          );
        else {
          this.dataModel.CurrencyCode = this.BaseCurrency;
        }

        CompanyCurrencyService.getByCurrencyCode(
          this.dataModel.CurrencyCode
        ).then((res) => {
          if (res.data.value.length > 0) {
            this.dataModel.ExchangeRate = res.data.value[0].SellRate;
            this.dataModel.BuyRate = res.data.value[0].SellRate;
          }
        });

        this.SupplierCode = this.dataModel.SupplierCode;
        this.dataModel.DateIn = new Date();

        this.setLoading = false;
        this.loaded = true;

        this.reload = false;
      }
    },
    async setDateInValidation() {
      var currentPaymentDate = undefined;
      if (this.baseView.mode == "review")
        currentPaymentDate = new Date(this.dataModel.DateIn.replace("Z", ""));
      else currentPaymentDate = this.PaymentMinDate;

      SupplierPaymentService.getActiveAccountingPeriodStartDate()
        .then((startDateResult) => {
          if (startDateResult) {
            let accountingPeriodStartDate = new Date(
              startDateResult.data.value[0].StartDate.replace("Z", "")
            );

            if (
              this.baseView.mode == "review" &&
              currentPaymentDate.getTime() > accountingPeriodStartDate.getTime()
            ) {
              this.PaymentMinDate = currentPaymentDate;
            } else {
              this.PaymentMinDate = accountingPeriodStartDate;
            }
          } else {
            this.PaymentMinDate = currentPaymentDate;
          }
        })
        .catch(() => {
          this.PaymentMinDate = currentPaymentDate;
        });

      SupplierPaymentService.getActiveAccountingPeriodEndDate().then(
        (endDateResult) => {
          if (endDateResult) {
            let accountingPeriodEndDate = endDateResult.data.value[0].EndDate;
            this.PaymentMaxDate = new Date(
              accountingPeriodEndDate.replace("Z", "")
            );
          }
        }
      );
    },
    supplierPaymentPostProcess(data) {
      this.headerData = data;
      data.Status = data.FriendlyStatus;
      data.BankAccountCode = `${data.BankAccountCode}`;
      this.displayCurrencyCode = data.CurrencyCode;

      if (this.baseView.mode == "review") {
        data.DiscountAmount = FxToBaseCurrency(
          data.FXDiscountAmount,
          data.ExchangeRate
        );
      }

      return data;
    },

    checkBoxValueChange(fieldData, recordData) {
      if (!fieldData.event) {
        return;
      }

      var gridItems =
        this.baseView.mode != "review"
          ? this.localDataSource._array
          : [...recordData.component.getDataSource().items()];

      if (recordData.rowType == "header") {
        if (fieldData.value == undefined) return;
        else {
          if (fieldData.value == true) {
            var selectedItems = gridItems.filter((x) => x.CheckInclude);
            var disabledItems = gridItems.filter((x) => x.Disabled);
            if (
              selectedItems.length ==
              gridItems.length - disabledItems.length
            ) {
              fieldData.value = false;
            }
          }

          this.updateHeaderCheckBoxValue(fieldData.value);
          gridItems.forEach((element) => {
            if (fieldData.value) {
              element.CheckInclude = true;
              element.FXAllocationAmount = element.FXBalance;
              element.AllocationAmount = FxToBaseCurrency(
                element.FXBalance,
                element.ExchangeRate
              );
            } else {
              element.CheckInclude = false;
              element.FXAllocationAmount = 0;
              element.AllocationAmount = 0.0;
              element.Discount = 0;
              element.FXDiscount = 0;
            }

            this.mergeWithReviewView(fieldData.value, element);
          });
        }
      } else {
        recordData.data.CheckInclude = fieldData.value ? true : false;

        recordData.data["FXAllocationAmount"] = recordData.data.CheckInclude
          ? recordData.data["FXBalance"]
          : 0;

        if (recordData.data.CheckInclude) {
          recordData.data["AllocationAmount"] = FxToBaseCurrency(
            recordData.data["FXBalance"],
            recordData.data.ExchangeRate
          );
        } else {
          recordData.data["AllocationAmount"] = 0;
          recordData.data["Discount"] = 0;
          recordData.data["FXDiscount"] = 0;
        }

        this.mergeWithReviewView(fieldData.value, recordData.data);
        this.updateHeaderCheckBox(gridItems);
      }

      if (
        this.$refs["supplier-payment"] &&
        this.$refs["supplier-payment"].$refs["transactionGrid"]
      )
        this.$refs["supplier-payment"].$refs["transactionGrid"].reSizeGrid();
    },

    mergeWithReviewView(value, item) {
      var index = this.reviewDataSource.findIndex(
        (x) => x.GoodsInCode == item.GoodsInCode && x.ItemCode == item.ItemCode
      );
      if (!value) {
        if (index != -1) {
          this.removeFromReview(index);
        }
      } else {
        if (index != -1) {
          this.removeFromReview(index);
        }
        this.addToReview(item);
      }
    },

    removeFromReview(index) {
      this.reviewDataSource.splice(index, 1);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },

    addToReview(item) {
      item.CheckInclude = true;
      this.reviewDataSource.push(item);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },

    async updateHeaderCheckBox(gridItems) {
      if (
        gridItems.length == 0 ||
        !this.$refs["supplier-payment"].$refs["transactionGrid"].$refs[
          "cx-CheckInclude"
        ]
      ) {
        return;
      }

      let count = 0;
      gridItems.forEach(async (element) => {
        if (element.CheckInclude) count = count + 1;
      });

      setTimeout(() => {
        if (count > 0 && count != gridItems.length) {
          // getInstanceHeader.option("value", undefined);
          this.updateHeaderCheckBoxValue(undefined);
        } else if (count == 0) {
          // getInstanceHeader.option("value", false);
          this.updateHeaderCheckBoxValue(false);
        } else if (count == gridItems.length) {
          // getInstanceHeader.option("value", true);
          this.updateHeaderCheckBoxValue(true);
        }
        setTimeout(() => {
          this.$refs["supplier-payment"].$refs["transactionGrid"].reSizeGrid();
        }, 200);
      }, 100);
    },
    updateHeaderCheckBoxValue(value) {
      var refHeadInstance = this.$refs["supplier-payment"].$refs[
        "transactionGrid"
      ].$refs["cx-CheckInclude"].getSeletcAllRef().instance;
      refHeadInstance.blur();
      var checkBoxHeader = refHeadInstance.element();
      var getInstanceHeader = CheckBox.getInstance(checkBoxHeader);
      getInstanceHeader.option("value", value);
      this.SelectedOnHeader = value;
    },

    async valuechange() {
      await SupplierService.getByCode(this.dataModel.SupplierCode);
    },

    roundingValueChange() {
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++
      );
    },
    onExchangeRateChange() {
      var dataGrid = this.$refs[
        "supplier-payment"
      ].$refs.transactionGrid.getGridInstance();

      let items = dataGrid.getDataSource().items();

      this.dataModel.IncTaxAmount = (
        this.dataModel.FXIncTaxAmount / this.dataModel.ExchangeRate
      ).round2Decimal();
      // this.dataModel.FXIncTaxAmount = (this.dataModel.IncTaxAmount * this.dataModel.ExchangeRate).round2Decimal();

      items.forEach((record) => {
        record.GainOrLoss = this.calculateGainOrLoss(record);
      });
    },
    calculateGainOrLoss(lineData) {
      // var dataGrid = this.$refs[
      //   "supplier-payment"
      // ].$refs.transactionGrid.getGridInstance();

      // let items = dataGrid.getDataSource().items();
      /*
      let baseAmountTotal = 0;
      items.forEach((element) => {
        if (element.CheckInclude)
          baseAmountTotal = (
            baseAmountTotal + element.AllocationAmount
          ).roundNumber(2);
      });
*/
      let headerBaseAmount = this.dataModel.IncTaxAmount;
      let headerFXBaseAmount = this.dataModel.FXIncTaxAmount;
      if (this.baseView.mode != "create") {
        headerBaseAmount = this.$refs["supplier-payment"].getTransactionData()
          .IncTaxAmount;
      }

      if (headerFXBaseAmount != 0) {
        let fxLineTotal = (
          lineData.FXDiscount + lineData.FXAllocationAmount
        ).roundNumber(2);

        let lineTotal = (
          lineData.Discount + lineData.AllocationAmount
        ).roundNumber(2);
        return (
          -1 *
          (
            lineTotal -
            (headerBaseAmount * fxLineTotal) / headerFXBaseAmount
          ).roundNumber(2)
        );
      } else return 0;
    },
    fxAmountValueChange(e) {
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++
      );

      if (e.value) {
        this.dataModel.Amount = (
          this.dataModel.FXIncTaxAmount / this.dataModel.ExchangeRate
        ).round2Decimal();
        this.dataModel.IncTaxAmount = (
          e.value / this.dataModel.ExchangeRate
        ).round2Decimal();
      } else {
        this.dataModel.Amount = 0;
        this.dataModel.IncTaxAmount = 0;
        var dataGrid = this.$refs[
          "supplier-payment"
        ].$refs.transactionGrid.getGridInstance();

        let items = dataGrid.getDataSource().items();
        items.forEach((record) => {
          record.GainOrLoss = 0;
        });
      }
    },
    amountValueChange(e) {
      // this.dataModel.FXIncTaxAmount = (
      //   e.value * this.dataModel.ExchangeRate
      // ).round2Decimal();

      if (e.value) {
        if (this.getCurrencyCode != this.BaseCurrency) {
          if (this.dataModel.FXIncTaxAmount == 0) {
            this.dataModel.FXIncTaxAmount = (
              e.value * this.dataModel.ExchangeRate
            ).round2Decimal();
          } else {
            this.dataModel.ExchangeRate = (
              this.dataModel.FXIncTaxAmount / e.value
            ).roundNumber(4);

            var dataGrid = this.$refs[
              "supplier-payment"
            ].$refs.transactionGrid.getGridInstance();

            let items = dataGrid.getDataSource().items();
            items.forEach((record) => {
              record.GainOrLoss = this.calculateGainOrLoss(record);
            });
          }
        } else {
          this.dataModel.FXIncTaxAmount = (
            e.value * this.dataModel.ExchangeRate
          ).round2Decimal();
        }
      } else {
        this.dataModel.FXIncTaxAmount = 0;
      }
    },

    async BankAccountNameValueChanged(e) {
      let itemData = e.itemData;
      if (!itemData) {
        return;
      }
    },

    doValidation(msg) {
      this.validationSummary = [];
      this.validationSummary.push({
        message: msg,
      });
    },

    async saveSupplierPayment(data, gridItems) {
      this.$logger.debug("saveSupplierPayment ", data);
      this.$logger.debug("saveSupplierPayment gridItems", gridItems);

      this.validationSummary = [];
      let payload = {
        // AccountingPeriodCode: data.AccountingPeriodCode, -- this is set by the API layer
        RaisedBy: data.PayeeName,
        Reference: data.Reference,
        DateIn: data.DateIn.toSaveDate(),
        BankAccountCode: parseInt(data.BankAccountCode),
        SupplierCode: data.SupplierCode,
        PayeeName: data.PayeeName,
        BankAccountName: data.BankAccountName,
        BankAccountNo: data.BankAccountNo,
        BSBNO: data.BSBNO,
        ChequeDate: data.DateIn.toSaveDate(),
        ChequeNo: data.ChequeNo,
        PresentedDate: data.PresentedDate
          ? new Date(data.PresentedDate).toSaveDate()
          : null,
        FXIncTaxAmount: data.FXIncTaxAmount,
        CurrencyCode: data.CurrencyCode,
        ExchangeRate: data.ExchangeRate,
        BuyRate: data.BuyRate,
        // IncTaxAmount: FxToBaseCurrency(data.FXIncTaxAmount, data.ExchangeRate),
        IncTaxAmount: data.IncTaxAmount,
        Presented: "",
        FXDiscountAmount: data.FXDiscountAmount,
        FXVarianceRounding: data.FXVarianceRounding,
        CashPaymentDetails: [],
      };

      gridItems.forEach((el) => {
        if (!el.CheckInclude) return;

        // eslint-disable-next-line no-console
        console.log(
          "CX LOG >> el.FXAmount ",
          el.FXAmount,
          el.FXAmount.roundNumber(2)
        );

        /*
          console.log("CX LOG >> el.FXAmount ", el.FXAmount, el.FXAmount.roundNumber(2))
          console.log("CX LOG >> data.ExchangeRate ", data.ExchangeRate)
          console.log("CX LOG >> (el.FXAmount.roundNumber(2) / data.ExchangeRate).roundNumber(2) ", (el.FXAmount.roundNumber(2) / data.ExchangeRate).roundNumber(2))
          console.log("CX LOG >> el.Amount ",el.Amount)
          console.log("CX LOG >> FXVarianceAmount ",   (el.FXAmount.roundNumber(2) / data.ExchangeRate).roundNumber(2) - el.Amount)
            */

        let obj = {
          CashPaymentCode: 0,
          BranchCode: el.BranchCode,
          DivisionCode: el.DivisionCode,
          PaymentAPDataXRef: el.PaymentAPDataXRef,
          InvoiceAPDataXRef: el.AccountsPayableCode,
          ExchangeRate: el.ExchangeRate,
          FXAllocationAmount: el.FXAllocationAmount.roundNumber(2),
          FXDiscountAmount: el.FXDiscount,
          FXVarianceAmount:
            this.getCurrencyCode == "AUD" // This is a HACK. It is possible that COMPANIES.CURRENCY != AUD
              ? 0
              : //  (
                //    el.FXAllocationAmount * (data.FXAmount / data.Amount) -
                //    el.FXAllocationAmount * (el.FXBalance / el.Balance)
                //  )
                // FxToBaseCurrency(el.FXAllocationAmount, data.ExchangeRate) -
                // FxToBaseCurrency(el.FXAllocationAmount, el.ExchangeRate)
                el.GainOrLoss, // .roundNumber(2),

          AllocationAmount: FxToBaseCurrency(
            el.FXAllocationAmount,
            el.ExchangeRate
          ),
          DiscountAmount: el.Discount,
          // FxToBaseCurrency(el.FXDiscount, data.ExchangeRate),
          OriginalFXBalance: el.FXBalance,
          OriginalSupplierInvoice: el.Code,
        };

        payload.CashPaymentDetails.push(obj);
      });

      payload.VarianceAmount = payload.CashPaymentDetails.reduce(
        (prev, curr) => prev + curr.FXVarianceAmount,
        0.0
      );

      payload.FXDiscountAmount = payload.CashPaymentDetails.reduce(
        (prev, curr) => prev + curr.FXDiscountAmount,
        0.0
      );

      const allocationAmountTotal = payload.CashPaymentDetails.reduce(
        (prev, curr) =>
          (
            prev +
            curr.AllocationAmount.roundNumber(2) +
            curr.DiscountAmount.roundNumber(2)
          ).roundNumber(2),
        0.0
      );

      payload.FXVarianceRounding = (
        (
          payload.IncTaxAmount +
          (payload.FXDiscountAmount / payload.ExchangeRate).roundNumber(2) -
          allocationAmountTotal
        ).roundNumber(2) - payload.VarianceAmount
      ).roundNumber(2);

      var total = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) {
          total = (total + element.FXAllocationAmount).roundNumber(4);
        }
      });
      var footerbalance = data.FXIncTaxAmount - total;
      if (payload.CashPaymentDetails.length == 0) {
        this.validationSummary.push({
          message: "No line item has been selected",
        });
      } else if (footerbalance != 0) {
        this.validationSummary.push({
          message: "The payment is not balanced",
        });
      } else {
        this.setLoading = true;

        await SupplierPaymentService.saveSupplierPayment(payload)
          .then((res) => {
            this.setLoading = false;
            this.$notify(
              `Supplier payment ${res.data.Code} saved successfully`,
              "success"
            );

            this.setIgnoreRouteChangeConfirmation();

            setTimeout(() => {
              this.$router
                .push({
                  path: `/supplier-payment/review/${res.data.Code}`,
                })
                .then(() => {
                  this.reload = true;
                  this.initialized();
                });
              // location.reload();
            }, 10);
          })
          .catch((error) => {
            this.serverError = {
              err: error,
              msg: "Supplier payment save failed",
              time: new Date().getTime(),
            };

            this.setLoading = false;
          });
      }
    },

    PostProcess(data) {
      data.forEach((element) => {
        element["CheckInclude"] = true;
        element.BranchCode = this.defaultDataModel.DefaultBranchCode;
        element.DivisionCode = this.defaultDataModel.DefaultDivisionCode;
        element.FXDiscount = 0;
        element.Discount = 0;

        if (this.baseView.mode == "create") {
          element.FXBalance = element.FXBalance || 0;
          element.FXAllocationAmount = element.FXBalance;
          element.AllocationAmount = FxToBaseCurrency(
            element.FXBalance,
            element.ExchangeRate
          );
          element.GainOrLoss = this.calculateGainOrLoss(element);
        } else if (this.baseView.mode == "review") {
          element.Discount = FxToBaseCurrency(
            element.FXDiscountAmount,
            element.ExchangeRate
          );
          element.AllocationAmount = FxToBaseCurrency(
            element.FXAllocationAmount,
            element.ExchangeRate
          );
          element.GainOrLoss = element.FXVarianceAmount;
        }
      });
      this.gridData = data;
      setTimeout(() => {
        this.updateHeaderCheckBox(data);
      }, 1000);

      return data;
    },
  },
};
</script>
